import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  setMenteeModules,
  viewMiscellaneousMenteeModulesStateSelector,
} from 'features/moduleManagement';
import Field from 'components/Field';
import MenteeModulesTable from '../MenteeModulesTable';
import MiscellaneousMenteeModulesTable from '../MiscellaneousMenteeModulesTable';

function MenteeModulesTableRenderer({ menteeModules }) {
  const dispatch = useDispatch();
  const isMiscellaneousMenteeModules = useSelector(
    viewMiscellaneousMenteeModulesStateSelector
  );

  useEffect(() => {
    dispatch(setMenteeModules(menteeModules));
  }, [dispatch, menteeModules]);

  if (isMiscellaneousMenteeModules) {
    return (
      <Field
        label="Modules Present in Miscellaneous"
        labelClassName="h3"
        className="m-t-s"
      >
        <MiscellaneousMenteeModulesTable />
      </Field>
    );
  } else {
    return (
      <Field
        label="Modules Present in Core Skills & Curriculum"
        labelClassName="h3"
        className="m-t-s"
      >
        <MenteeModulesTable />
      </Field>
    );
  }
}

export default MenteeModulesTableRenderer;
